import ColorStyles from '@Styles/colors.scss';
import { isNil } from 'lodash';
import React, { useRef, useState } from 'react';
import FolderStyles from '@Components/FolderComponents/Folders.scss';
import PopoverMenu from '@Components/PopoverMenu/PopoverMenu';
import PopoverMenuItem from '@Components/PopoverMenu/PopoverMenuItem';

interface IQcSnapshotFolderMenuProps {
    id: string;
    folderId: any;
}

const QcSnapshotFolderMenu = (props: IQcSnapshotFolderMenuProps) => {
    const { id, folderId } = props;

    const menuRef = useRef<PopoverMenu>();

    const reportUrl = isNil(folderId)
        ? `${process.env.LOOKER_URL_REPORT}`
        : `${process.env.LOOKER_URL_REPORT}/page/p_iu6ykjgkcd/view?params={"df22":"include%EE%80%800%EE%80%80IN%EE%80%80${folderId}"}`;

    const openReportLink = () => {
        window.open(reportUrl, '_blank');
    };

    return (
        <div className={FolderStyles.foMenuContainer}>
            <PopoverMenu
                id={id}
                ref={menuRef}
                iconColour={ColorStyles.ikeGradient1}
            >
                <PopoverMenuItem
                    id={`${id}-report-link`}
                    onClick={() => openReportLink()}
                    parentRef={menuRef}
                    text={'View Report'}
                />
            </PopoverMenu>
        </div>
    );
};

export default QcSnapshotFolderMenu;
